<div class="page">
  <div class="page-head">
    <div>
      <h2>{{ pageTitle() || 'Certificate of Insurance' }}</h2>
      <p>The member's policy certificate — view, print, or download it.</p>
    </div>
    <p-button label="Back" icon="pi pi-arrow-left" [text]="true" (onClick)="back()" />
  </div>

  <div class="card coi-card">
    @if (memberId()) {
      <app-coi-view [memberId]="memberId()" />
    } @else {
      <div class="state"><i class="pi pi-exclamation-triangle"></i><p>No member reference provided.</p></div>
    }
  </div>

  <div class="page-foot">
    <p-button label="Find another certificate" icon="pi pi-search" [outlined]="true" (onClick)="findAnother()" />
  </div>
</div>
